import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building, User, Server, Shield, Cookie } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEOHead from '../components/SEOHead';

export default function MentionsLegalesPage() {
    return (
        <>
            <SEOHead 
                title="Mentions Légales | O.C.A Piscine"
                description="Mentions légales du site O.C.A Piscine. Informations sur l'éditeur, l'hébergeur et la protection des données."
            />
            <div className="min-h-screen pt-20 pb-12 bg-gradient-to-b from-background to-muted/20">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Header */}
                    <div className="mb-8">
                        <Link to="/">
                            <Button variant="ghost" className="gap-2 mb-4">
                                <ArrowLeft className="h-4 w-4" />
                                Retour à l'accueil
                            </Button>
                        </Link>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="p-3 rounded-2xl bg-primary/10">
                                <Building className="h-8 w-8 text-primary" />
                            </div>
                            <div>
                                <h1 className="font-heading text-3xl font-bold">Mentions Légales</h1>
                                <p className="text-muted-foreground">Informations légales obligatoires</p>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-6">
                        
                        {/* Éditeur */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <Building className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Éditeur du site</h2>
                            </div>
                            <div className="space-y-2 text-muted-foreground">
                                <p><strong>Raison sociale :</strong> O.C.A SHOP</p>
                                <p><strong>Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</p>
                                <p><strong>Capital social :</strong> 100 €</p>
                                <p><strong>Siège social :</strong> 8 Rue Roger Chieusse, 83780 Flayosc, France</p>
                                <p><strong>SIRET :</strong> 928 454 719 00016</p>
                                <p><strong>SIREN :</strong> 928 454 719</p>
                                <p><strong>N° TVA Intracommunautaire :</strong> FR51 928 454 719</p>
                                <p><strong>RCS :</strong> Draguignan</p>
                                <p><strong>Email :</strong> oca.directionpaca@gmail.com</p>
                                <p><strong>Téléphone :</strong> 06 51 96 14 74</p>
                            </div>
                        </section>

                        {/* Directeur de publication */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <User className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Directeur de la publication</h2>
                            </div>
                            <p className="text-muted-foreground">
                                <strong>M. David DECAUDIN GUILLOT</strong><br />
                                Président de la société O.C.A SHOP
                            </p>
                        </section>

                        {/* Hébergeur */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <Server className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Hébergement</h2>
                            </div>
                            <div className="space-y-2 text-muted-foreground">
                                <p><strong>Hébergeur :</strong> Emergent Labs Inc.</p>
                                <p><strong>Site web :</strong> www.emergentagent.com</p>
                            </div>
                        </section>

                        {/* Propriété intellectuelle */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <Shield className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Propriété intellectuelle</h2>
                            </div>
                            <p className="text-muted-foreground mb-4">
                                L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
                                est la propriété exclusive de O.C.A SHOP ou de ses partenaires et est protégé par les lois 
                                françaises et internationales relatives à la propriété intellectuelle.
                            </p>
                            <p className="text-muted-foreground mb-4">
                                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
                                des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans 
                                l'autorisation écrite préalable de O.C.A SHOP.
                            </p>
                            <p className="text-muted-foreground">
                                Toute exploitation non autorisée du site ou de son contenu sera considérée comme constitutive 
                                d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants 
                                du Code de la Propriété Intellectuelle.
                            </p>
                        </section>

                        {/* Protection des données */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <Shield className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Protection des données personnelles (RGPD)</h2>
                            </div>
                            <p className="text-muted-foreground mb-4">
                                Conformément au Règlement Général sur la Protection des Données (RGPD) du 27 avril 2016 
                                et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez des droits suivants :
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-1">
                                <li>Droit d'accès à vos données personnelles</li>
                                <li>Droit de rectification de vos données</li>
                                <li>Droit à l'effacement de vos données</li>
                                <li>Droit à la limitation du traitement</li>
                                <li>Droit à la portabilité de vos données</li>
                                <li>Droit d'opposition au traitement</li>
                            </ul>
                            <p className="text-muted-foreground mb-4">
                                <strong>Responsable du traitement :</strong> O.C.A SHOP<br />
                                <strong>Finalités du traitement :</strong> Gestion des commandes, relation client, marketing (avec consentement)<br />
                                <strong>Durée de conservation :</strong> 3 ans après le dernier contact pour les prospects, 
                                durée de la relation contractuelle + 5 ans pour les clients (obligations légales)
                            </p>
                            <p className="text-muted-foreground">
                                Pour exercer vos droits, contactez-nous à : <strong>oca.directionpaca@gmail.com</strong><br />
                                Vous pouvez également introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.cnil.fr</a>
                            </p>
                        </section>

                        {/* Cookies */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <div className="flex items-center gap-2 mb-4">
                                <Cookie className="h-5 w-5 text-primary" />
                                <h2 className="text-xl font-bold">Cookies</h2>
                            </div>
                            <p className="text-muted-foreground mb-4">
                                Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic.
                            </p>
                            <p className="text-muted-foreground mb-4">
                                <strong>Types de cookies utilisés :</strong>
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-1">
                                <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site (session, panier)</li>
                                <li><strong>Cookies analytiques :</strong> permettent de mesurer l'audience du site</li>
                            </ul>
                            <p className="text-muted-foreground">
                                Vous pouvez configurer votre navigateur pour refuser les cookies. Toutefois, certaines 
                                fonctionnalités du site pourraient ne plus être accessibles.
                            </p>
                        </section>

                        {/* Liens */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <h2 className="text-xl font-bold mb-4">Liens hypertextes</h2>
                            <p className="text-muted-foreground mb-4">
                                Le site peut contenir des liens vers d'autres sites internet. O.C.A SHOP ne saurait être 
                                tenu responsable du contenu de ces sites externes.
                            </p>
                            <p className="text-muted-foreground">
                                La création de liens hypertextes vers le site www.ocapiscine.fr est soumise à l'autorisation 
                                préalable de O.C.A SHOP.
                            </p>
                        </section>

                        {/* Crédits */}
                        <section className="bg-card rounded-2xl p-6 shadow-sm border">
                            <h2 className="text-xl font-bold mb-4">Crédits</h2>
                            <p className="text-muted-foreground">
                                <strong>Conception et développement :</strong> Emergent Labs<br />
                                <strong>Images :</strong> O.C.A SHOP, Unsplash, Pexels
                            </p>
                        </section>

                    </div>

                    {/* Links */}
                    <div className="mt-12 flex flex-wrap justify-center gap-4">
                        <Link to="/cgv">
                            <Button variant="outline" className="rounded-full">
                                Conditions Générales de Vente
                            </Button>
                        </Link>
                        <Link to="/">
                            <Button variant="outline" className="rounded-full">
                                Retour à l'accueil
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
